import React from "react";
import { Box, Flex, Grid, Heading, Text, VStack } from "@chakra-ui/react";
import { useColorModeValue } from "../components/ui/color-mode";

const howItWorksSteps = [
  "Search for a public company by ticker or company name.",
  "Review financial statements, SEC filings, charts, and filing-sourced metrics.",
  "Use reverse DCF and traditional DCF tools to compare intrinsic value with the current market narrative.",
];

const HomeHowItWorksSection = () => {
  const bandBg = useColorModeValue("white", "gray.900");
  const subtleBg = useColorModeValue("gray.100", "gray.800");
  const borderColor = useColorModeValue("gray.200", "gray.700");
  const mutedTextColor = useColorModeValue("gray.600", "gray.300");
  const linkColor = useColorModeValue("teal.700", "teal.300");

  return (
    <Box as="section" bg={bandBg} borderYWidth="1px" borderColor={borderColor}>
      <Box maxW="1180px" mx="auto" px={{ base: 5, md: 8 }} py={{ base: 10, md: 14 }}>
        <Grid templateColumns={{ base: "1fr", md: "0.8fr 1.2fr" }} gap={8}>
          <Box>
            <Heading as="h2" size="xl">
              How it works
            </Heading>
            <Text mt={3} color={mutedTextColor} lineHeight="1.7">
              DCF Teacher is built for investors who want to understand the assumptions behind a
              valuation instead of stopping at a headline multiple.
            </Text>
          </Box>
          <VStack as="ol" align="stretch" gap={3} m={0} pl={0} listStyleType="none">
            {howItWorksSteps.map((step, index) => (
              <Flex
                as="li"
                key={step}
                gap={4}
                bg={subtleBg}
                borderWidth="1px"
                borderColor={borderColor}
                borderRadius="md"
                p={4}
              >
                <Text fontWeight="bold" color={linkColor}>
                  {index + 1}
                </Text>
                <Text color={mutedTextColor}>{step}</Text>
              </Flex>
            ))}
          </VStack>
        </Grid>
      </Box>
    </Box>
  );
};

export default HomeHowItWorksSection;
